import { render, staticRenderFns } from "./FragranceDescription.vue?vue&type=template&id=58826e18&scoped=true"
import script from "./FragranceDescription.vue?vue&type=script&lang=js"
export * from "./FragranceDescription.vue?vue&type=script&lang=js"
import style0 from "./FragranceDescription.vue?vue&type=style&index=0&id=58826e18&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58826e18",
  null
  
)

export default component.exports